var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.currentRound.steps ? _c('div', {
    staticClass: "steps-container",
    attrs: {
      "transition": "fade"
    }
  }, [_c('div', {
    staticClass: "fitb-images-container"
  }, [_c('div', {
    staticClass: "fitb-images"
  }, _vm._l(_vm.roundStepsWithImages, function (step, stepIndex) {
    var _step$activityImage, _step$activityImage$i, _step$activityImage2, _step$activityImage2$;
    return _c('article', {
      key: stepIndex,
      staticStyle: {
        "height": "100px"
      }
    }, [_c('img', {
      class: ("image-sentence-" + ((_step$activityImage = step.activityImage) === null || _step$activityImage === void 0 ? void 0 : (_step$activityImage$i = _step$activityImage.image) === null || _step$activityImage$i === void 0 ? void 0 : _step$activityImage$i.title)),
      staticStyle: {
        "width": "100%",
        "height": "auto"
      },
      attrs: {
        "alt": "Fill in image",
        "src": (_step$activityImage2 = step.activityImage) === null || _step$activityImage2 === void 0 ? void 0 : (_step$activityImage2$ = _step$activityImage2.image) === null || _step$activityImage2$ === void 0 ? void 0 : _step$activityImage2$.src
      }
    })]);
  }), 0)]), _c('div', {
    staticClass: "fitb-container"
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    var _step$optionalWord, _step$optionalWord$sp;
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: stepIndex % 2 === 0,
        expression: "stepIndex % 2 === 0"
      }],
      key: stepIndex,
      class: ("sentence-" + stepIndex),
      style: {
        visibility: _vm.progress.stepIndex >= stepIndex ? 'visible' : 'hidden'
      }
    }, [_c('h3', {
      attrs: {
        "transition": "fade"
      }
    }, [_vm._v("\n              " + _vm._s((_step$optionalWord = step.optionalWord) === null || _step$optionalWord === void 0 ? void 0 : (_step$optionalWord$sp = _step$optionalWord.split(step.answer)) === null || _step$optionalWord$sp === void 0 ? void 0 : _step$optionalWord$sp[0]) + "\n            ")]), _c('div', {
      staticClass: "prefix-sentence"
    }, [_c('text-display-list', [_c('li', {
      attrs: {
        "transition": "fade"
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    })], 1)])], 1), _c('div', {
      staticClass: "sentence-expl"
    }, [_vm.currentRound.steps[stepIndex + 1] ? _c('text-display-list', [_c('li', {
      attrs: {
        "transition": "fade"
      }
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": _vm.currentRound.steps[stepIndex + 1].answer,
        "text-step": stepIndex + 1
      }
    })], 1)]) : _vm._e()], 1)]);
  }), 0)]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }